import { render, staticRenderFns } from "./LogoItem.vue?vue&type=template&id=47482a9c&scoped=true&lang=pug&"
import script from "./LogoItem.vue?vue&type=script&lang=js&"
export * from "./LogoItem.vue?vue&type=script&lang=js&"
import style0 from "./LogoItem.vue?vue&type=style&index=0&id=47482a9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47482a9c",
  null
  
)

export default component.exports